import React from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import { elementMatchesAny } from "../Global/tools.js";

import NanoFlex from "../Global/NanoFlex.js";
import Type from "../Global/Typography.js";
import Dropdown from "./../Nano/Dropdown.js";
import PerformanceIndicator from "./../Micro/PerformanceIndicator.js";

//Images
import { ReactComponent as ArrowUp } from "../Global/Icons/arrowUp.svg";
import { ReactComponent as ArrowDown } from "../Global/Icons/arrowDown.svg";
import { ReactComponent as Check } from "../Global/Icons/check.svg";
import { ReactComponent as Info } from "../Global/Icons/info.svg";
const multiple = nota.global.multiple;

const StyledHeaderTableSearchList = styled.div`
  width: 100%;
  position: sticky;
  top: ${(props) => (props.openRecapFilters ? "180px" : "120px")};
  z-index: 2;
  .headerWrapper {
    background-color: ${nota.color.neutral.NeuFour};
    padding: ${multiple + "px"} ${multiple / 2 + "px"} ${multiple + "px"} 0;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
    display: grid;
    /* grid-template-columns: 200px calc(100% - 200px); */
    grid-template-columns: 230px calc(100% - 230px);
    .headerItem {
      cursor: pointer;
      /* margin-right: ${multiple * 2 + "px"}; */
      user-select: none;
      position: relative;
      .checkWrapper {
        padding: 5px 0;
        svg {
          width: 11px;
          height: 9px;
          path {
            fill: ${(props) => (props.isAllSelected ? nota.color.main.default : nota.color.neutral.NeuThree)};
          }
        }
      }
      .titleWrapper {
      }
      .sortWrapper {
        width: 10px;
        padding: 2px;

        svg {
          width: 8px;
          path {
            fill: ${nota.color.neutral.NeuThree};
          }
        }
      }
      .enabled {
        svg {
          path {
            fill: ${nota.color.neutral.NeuOne};
          }
        }
      }
      /* &:hover {
        opacity: 0.5;
      } */
      /* &:first-child {
        margin-right: 0;
      } */
      &:last-child {
        margin-right: 0;
      }

      .headerInfoLabel {
        position: absolute;
        bottom: -26px;
        right: 4px;
        width: 20px;
        background-color: ${nota.color.neutral.white};
        height: 17px;
        border-radius: 0 0 16px 16px;
        cursor: pointer;
        z-index: -1;
        box-shadow: 0px 2px 2px rgb(0 0 0 / 25%);
        .infoIcon {
          height: auto;
          width: 14px;
          path {
            /* fill: ${nota.color.main.default}; */
          }
        }
      }
    }
    .xxs {
      flex: 0;
      min-width: 35px;
      &:hover {
        opacity: 0.5;
        svg {
          path {
            fill: ${nota.color.main.default};
          }
        }
      }
    }
    .xs {
      flex: 2;
    }
    .s {
      flex: 3;
    }
    .m {
      flex: 4;
    }
    .l {
      flex: 6;
    }
  }
  .headerItemsContainer {
    padding-left: 8px;
    .headerItem {
      margin-right: 8px;
    }
  }
  .dropdown-content {
    left: unset;
    transform: translate(0%);
    right: -21px;
    margin: 16px;
  }
  .tooltipWrapper {
    min-width: 300px;
    border: 1px solid ${nota.color.neutral.NeuTwo};
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    padding: ${multiple + "px"}; /* 8px */
    position: relative;
    cursor: default;
    &:after,
    &:before {
      bottom: 100%;
      right: 5px;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    &:after {
      border-color: rgba(255, 255, 255, 0);
      border-bottom-color: ${nota.color.neutral.white};
      border-width: 8px;
      margin-right: 0px;
    }
    &:before {
      border-color: rgba(0, 168, 225, 0);
      border-bottom-color: ${nota.color.neutral.NeuTwo};
      border-width: 9px;
      margin-right: -1px;
    }
    .optionLine {
      padding: ${multiple + "px"}; /* 8px */
      border-bottom: 0.5px solid ${nota.color.neutral.NeuFour};
      .performanceWrapper {
        margin-right: ${multiple * 2 + "px"}; /*16px */
      }
      p {
        letter-spacing: 1px;
        font-size: 12px;
        width: 100%;
      }

      &:last-child {
        border-bottom: 0;
      }
    }
    .specialOption {
      p {
        text-transform: uppercase;
        color: ${nota.color.main.default};
      }
    }
  }
`;

class HeaderTableSearchList extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: this.getColumns(),
      orderBy: this.props.orderBy ? this.props.orderBy : [],
    };
  }

  getColumns = () => {
    return [
      {
        name: "Country",
        label: this.translation.components.headerTableSearchList.country,
        sortExpression: "CHANNELS_GROUP",
        size: "s",
        isRating: false,
      },
      {
        name: "Channel",
        label: this.translation.components.headerTableSearchList.channel,
        sortExpression: "CHANNEL",
        size: "s",
        isRating: false,
      },
      {
        name: "Date",
        label: this.translation.components.headerTableSearchList.dateTime,
        sortExpression: "LAUNCHDATE",
        size: "s",
        isRating: false,
      },
      {
        name: "LocalTitle",
        label: this.translation.components.headerTableSearchList.localFormatTitle,
        sortExpression: "LOCALTITLE",
        size: "l",
        isRating: false,
      },
      {
        name: "SubGenre",
        label: this.translation.components.headerTableSearchList.subgenre,
        sortExpression: "SUBGENRE",
        size: "m",
        isRating: false,
      },
      {
        name: "FormatType",
        label: this.translation.components.headerTableSearchList.formatType,
        sortExpression: "ORIGINAL_TYPENAME",
        size: "s",
        isRating: false,
      },
      {
        name: "ShrPremiere",
        label: this.translation.components.headerTableSearchList.shrPremiere,
        sortExpression: "SHR_PREMIERE",
        size: "xs",
        isRating: true,
        tooltip: (
          <NanoFlex>
            <NanoFlex className="tooltipWrapper" flexDirection={"column"}>
              <NanoFlex className="optionLine">
                <Type.p>{this.translation.components.headerTableSearchList.shrPremiereTooltip}</Type.p>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>
        ),
      },
      {
        name: "ShrAverage",
        label: this.translation.components.headerTableSearchList.shrAverage,
        sortExpression: "SHR_AVERAGE",
        size: "xs",
        isRating: true,
        tooltip: (
          <NanoFlex>
            <NanoFlex className="tooltipWrapper" flexDirection={"column"}>
              <NanoFlex className="optionLine">
                <Type.p>{this.translation.components.headerTableSearchList.shrAverageTooltip}</Type.p>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>
        ),
      },
      // {
      //   name: "PerformanceColor",
      //   label: "Prem.",
      //   sortExpression: "PREM_PERFORMANCE",
      //   size: "xs",
      //   isRating: true,
      // },
      // {
      //   name: "AverageColor",
      //   label: "Avg.",
      //   sortExpression: "PERFORMANCE",
      //   size: "xs",
      //   isRating: true,
      // },
    ];
  };

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("languageChange", this.onHeaderTableSearchListLanguageChange, false);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.orderBy !== prevState.orderBy && this.props.onOrderByChange) {
      this.props.onOrderByChange(this.state.orderBy);
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("languageChange", this.onHeaderTableSearchListLanguageChange, false);
  }

  onHeaderTableSearchListLanguageChange = () => {
    this.setState({ columns: this.getColumns() });
  };

  onHeaderClick = (e, name) => {
    let orderBy = [...this.state.orderBy];
    let currentOrderBy = orderBy.find((o) => o.name === name);
    if (!currentOrderBy) {
      let column = this.state.columns.find((c) => c.name == name);
      currentOrderBy = { name: name, sortExpression: column.sortExpression, direction: null };
      orderBy.push(currentOrderBy);
    }

    switch (currentOrderBy.direction) {
      case null:
        currentOrderBy.direction = "Desc";
        break;
      case "Desc":
        currentOrderBy.direction = "Asc";
        break;
      case "Asc":
        currentOrderBy.direction = null;
        orderBy = orderBy.filter((o) => o.name !== currentOrderBy.name);
        break;
    }

    if (e.shiftKey) {
      this.setState({ orderBy: orderBy });
    } else {
      let current = orderBy.filter((o) => o.name === currentOrderBy.name);
      this.setState({ orderBy: current ? current : [] });
    }
  };

  onCheckClick = () => {
    if (this.props.onIsAllSelectedChange) {
      this.props.onIsAllSelectedChange(!this.props.isAllSelected);
    }
  };

  render() {
    return (
      <StyledHeaderTableSearchList isAllSelected={this.props.isAllSelected} openRecapFilters={this.props.openRecapFilters}>
        <NanoFlex className={`headerWrapper ${this.props.advancedSearchVisible ? "advancedSearchVisible" : ""}`}>
          <NanoFlex className="headerColumnWrapper">
            {/* CHECK */}
            <NanoFlex className="headerItem xxs">
              <NanoFlex className="checkWrapper" onClick={this.onCheckClick}>
                <Check />
              </NanoFlex>
            </NanoFlex>
            {/* IMAGE SPACE*/}
            <NanoFlex className="headerItem imgSpace">{/*EMPTY*/}</NanoFlex>
          </NanoFlex>

          <NanoFlex className="headerItemsContainer">
            {this.state.columns
              .filter((v) => {
                if (this.props.hideRatings && v.isRating) {
                  return false;
                } else return true;
              })
              .map((col) => {
                let orderBy = this.state.orderBy.find((o) => o.name === col.name);
                return (
                  <NanoFlex
                    key={col.name}
                    className={`headerItem ${col.size}`}
                    onClick={(e) => {
                      if (elementMatchesAny(e.target, [".headerInfoLabel"])) return;
                      this.onHeaderClick(e, col.name);
                    }}>
                    <NanoFlex className="titleWrapper" justifyContent="flex-start">
                      <Type.p>
                        <b>{col.label}</b>
                      </Type.p>
                    </NanoFlex>
                    <NanoFlex className="sortWrapper" flexDirection="column" justifyContent="flex-end">
                      <NanoFlex className={`sortIcon ${orderBy && orderBy.direction === "Asc" ? "enabled" : ""}`}>
                        <ArrowUp />
                      </NanoFlex>
                      <NanoFlex className={`sortIcon ${orderBy && orderBy.direction === "Desc" ? "enabled" : ""}`}>
                        <ArrowDown />
                      </NanoFlex>
                    </NanoFlex>
                    {col.tooltip && (
                      <NanoFlex className="headerInfoLabel">
                        <Dropdown enableHover onClickOutsideClose main={<Info className="infoIcon" />} content={col.tooltip} />
                      </NanoFlex>
                    )}
                  </NanoFlex>
                );
              })}
          </NanoFlex>
        </NanoFlex>
      </StyledHeaderTableSearchList>
    );
  }
}

// Set default props
HeaderTableSearchList.defaultProps = {
  orderBy: [],
};

export default HeaderTableSearchList;

// --- // Documentation // --- //
/*
import HeaderTableSearchList from './../Micro/HeaderTableSearchList.js';

<HeaderTableSearchList 
    isAllSelected={false}
    orderBy={[]}
/>
*/
